import React, { FC } from 'react';
import styles from './styles.module.css';
import { SearchIcon } from './search-icon';

export interface SearchBarProps {
  placeholder?: string;
  onSearch?: (value: string) => void;
  onClickSearch?: () => void;
  onChangeText?: (text: string) => void;
  value?: string;
  'aria-label'?: string;
}

export const SearchBar: FC<SearchBarProps> = ({
  placeholder = 'Como posso te ajudar?',
  onSearch,
  onClickSearch,
  onChangeText,
  value = '',
  'aria-label': ariaLabel,
}) => {
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (onClickSearch) {
      onClickSearch();
    } else if (onSearch) {
      onSearch(value);
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (onChangeText) {
      onChangeText(e.target.value);
    }
  };

  return (
    <form className={styles.searchContainer} onSubmit={handleSubmit}>
      <div className={styles.searchWrapper}>
        <SearchIcon className={styles.searchIcon} />
        <input
          type="search"
          name="search"
          className={styles.searchInput}
          placeholder={placeholder}
          value={value}
          onChange={handleChange}
          aria-label={ariaLabel}
        />
      </div>
      <button type="submit" className={styles.searchButton}>
        Buscar
      </button>
    </form>
  );
};
